<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-12">
          <div class="h2">{{routeName}}</div>
          <div class="row">
            <div class="col-md-3">
              <fg-select
                label="Subscription Type"
                v-model="subscriptionFilter"
                :list="status"
                selectedKey="id"
              >
              </fg-select>
            </div>
            <div class="col-md-3" v-if="corps">
              <fg-select
                label="Corporation"
                v-model="corporationFilter"
                :list="corps"
                selectedKey="name"
              >
              </fg-select>
            </div>
            <div class="col-md-3">
              <fg-select
                label="User Type"
                v-model="userFilter"
                :list="userStatus"
                selectedKey="name"
              >
              </fg-select>
            </div>
            <div class="col-md-3" v-if="packages">
              <fg-select
                label="User Package"
                v-model="packageFilter"
                :list="packages"
                selectedKey="packageId"
              >
              </fg-select>
            </div>
            <div class="col-md-6 text-center">
              <button type="button" @click="filterData()" class="btn btn-primary btn-fill btn-block">
                <i class="fa fa-search-plus" aria-hidden="true"></i>Filter
              </button>
              <br>
            </div>
            <div class="col-md-6 text-center">
              <button type="button" @click="resetFilters()" class="btn btn-primary btn-fill btn-block">
                Reset Filters
              </button>
              <br>
            </div>
          </div>
          <div class="col-md-12 left">
            <!--<div class="col-8" v-if="status.length">-->
              <!--<fg-select-->
                <!--v-model="filter"-->
                <!--:list="status"-->
                <!--selectedKey="id"-->
              <!--&gt;-->
              <!--</fg-select>-->
            <hr>
              <span v-if="subscribers.data.length && subscribers.data.length > 0">
                    <strong>Total Record: {{subscribers.data.length}}</strong><br>
                <a target="_blank" :href="makeOnlineUrl()" @click="downloadCSV()">Download as CSV</a>
              </span>
            </div>
        </div>
      </div>
      <div class="table-responsive text-center">
        <l-table class="table table-light table-bordered table-hover"
                 :columns="subscribers.columns" :data="subscribers.data">
          <template slot="table-row" v-if="subscribers.data.length">
            <tr v-for="(item, index) in subscribers.data" :key="index">
              <!--td><img :src="item.smallImage" alt="corporation-image" class="table-thumbnail"></td-->
              <td>{{item.userId}}</td>
              <td>{{item.firstName}}&nbsp;{{item.lastName}}</td>
              <td>{{item.email}}</td>
              <td>{{item.createdOnFmt}}</td>
              <td><span v-if="subscriptionFilter === 'CANCELLED'">{{item.lastUpdatedOnFmt}}</span><span v-else>N/A</span></td>
              <td>{{item.userType}}</td>
              <!--<td>-->
                <!--<span class="badge badge-success" v-if="item.active == '1'"> Active </span>-->
                <!--<span class="badge badge-danger" v-else> Inactive </span>-->
              <!--</td>-->
              <!--<td>-->
                <!--<div class="btn-group" role="group">-->
                  <!--<button class="btn btn-secondary btn-sm" @click="view(item)" v-tooltip.top-center="tooltips.view"><i class="fa fa-eye"></i></button>-->
                  <!--<button class="btn btn-info btn-sm" @click="edit(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>-->
                  <!--<button v-if="item.active == '1'" class="btn btn-danger btn-sm" @click="statusChange(item, true)" v-tooltip.top-center="tooltips.delete"><i class="fa fa-toggle-off"></i></button>-->
                  <!--<button class="btn btn-success btn-sm" v-else @click="statusChange(item, false)" v-tooltip.top-center="tooltips.activate"><i class="fa fa-toggle-on"></i></button>-->
                <!--</div>-->
              <!--</td>-->
            </tr>
          </template>
        </l-table>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  const columns = ['UserId', 'User Name', 'Email', 'Date Created', 'Date Cancelled', 'User Type'];
  export default {
    name: 'Subscribers',
    components: {
      LTable,
    },
    data() {
      return {
        downloadUrl: '',
        tooltips: {
          view: 'View',
          edit: 'Edit',
          delete: 'Inactivate',
          activate:'Activate',
        },
        subscriptionFilter: 'ALL',
        userFilter: '',
        corporationFilter: '',
        packageFilter: '',
        dateRef: 'Date Created',
        corps: [],
        packages: [],
        userStatus: [{id:"PURCHASE", name:'PURCHASE'}, {id:"TRIAL", name:'TRIAL'},{id:"GIFT", name:'GIFT'} ],
        status: [{id:"ALL", name:'ALL'}, {id:"REGISTERED", name:'REGISTERED'}, {id:"CONFIRMED", name:'CONFIRMED'}, {id:"CANCELLED", name:'CANCELLED'}],
        subscribers: {
          columns: [...columns],
          data: []
        }
      }
    },
    watch: {
//        'subscriptionFilter' (to, from) {
//            console.log('new value', to)
//            this.fetch ();
//      }
    },
    methods: {
      resetFilters () {
        this.subscriptionFilter = 'ALL'
        this.userFilter = ''
        this.corporationFilter = ''
        this.packageFilter = ''
        this.filterData();
      },
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS_CODES')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations codes : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchPackages () {
        this.$store.dispatch('FETCH_CORPORATIONS_PKGS')
          .then((res) => {
            this.packages = res;
            console.log("this.corporations pkgs : ", this.packages);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      downloadCSV () {
        this.$store.dispatch('DOWNLOAD_CSV', this.subscriptionFilter)
      },
      makeOnlineUrl () {
        let qryString = ''
        let subFilter = this.subscriptionFilter;
        let userFilter = this.userFilter;
        let pkgFilter = this.packageFilter !== '0' ? this.packageFilter : null;
        let corpFilter = this.corporationFilter !== '0' ? this.corporationFilter : null;
        qryString = `subscriptionType=${subFilter ? subFilter: null}&userType=${userFilter ? userFilter : null}&userPackageId=${pkgFilter ? pkgFilter : 0}&corporationName=${corpFilter ? corpFilter : null}`
        console.log('qury string', qryString);
        let href = window.location.href;
        let origin = ''
        if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
            origin = `https://adminapi1.dev-tonenetworks.com/v1/registration/downloadSubscriberCSVFiltered?${qryString}`
        } else {
          origin = `https://adminapi1.tonenetworks.com/v1/registration/downloadSubscriberCSVFiltered?${qryString}`
        }
        return origin
      },
      filterData () {
        let qryString = ''
        let subFilter = this.subscriptionFilter;
        let userFilter = this.userFilter;
        let pkgFilter = this.packageFilter !== '0' ? this.packageFilter : null;
        let corpFilter = this.corporationFilter !== '0' ? this.corporationFilter : null;
        qryString = `subscriptionType=${subFilter ? subFilter: null}&userType=${userFilter ? userFilter : null}&userPackageId=${pkgFilter ? pkgFilter : 0}&corporationName=${corpFilter ? corpFilter : null}`
        console.log('qury string', qryString);
        this.$store.dispatch('FETCH_SUBSCRIBERS_BY_QUERY', qryString)
          .then((res) => {
            if (res) {
              this.subscribers.data = res;
            } else {
              this.subscribers.data = []
            }
            console.log("this.subscriber.data : ", this.subscribers.data);
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
      fetch () {
        let filter = this.subscriptionFilter
        this.$store.dispatch('FETCH_SUBSCRIBERS')
          .then((res) => {
            let resultSet = res.payload;
            let filteredList = resultSet.filter( x => {
                return x.userFilter === filter
            })
            this.subscribers.data = filteredList;
            console.log("this.subscriber.data : ", this.subscribers.data);
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
      view(item){
        this.$store.commit('SET_SELECTED_CORPORATION', item);
        this.$router.push({ name: 'Corporation Details', params: { id:  item.corporationId}})
      },
      edit(item){
        this.$store.commit('SET_SELECTED_CORPORATION', item);
        this.$router.push({ name: 'Edit Corporation', params: { id: item.corporationId}});
      },
      create(){
        this.$router.push({ name: 'Create Corporation'})
      },
      statusChange(item, boolean){
        this.$store.dispatch('DELETE_CORPORATION', {corporationId: item.corporationId, isDelete: boolean})
          .then((res) => {
            console.log("DELETE_CORPORATION API res : ", res);
            this.fetch();
          })
          .catch(err => {
            console.log("DELETE_CORPORATION API error : ", err);
          })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
    },
    created() {
      this.fetchCorporations();
      this.fetchPackages();
      this.fetch();
    },
    computed:{
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      }
    }
  }
</script>

<style>
  .btn-icon{
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Subscriber.vue